export default __webpack_public_path__ + "images/5K.774d101.png";